import { GridBaseDataProvider } from '../../../../grid/GridBaseDataProvider';
import { DEFAULT_PAGE_SIZE, Filter, LiveSearchMetadataGridGetRowsResponse, SetFiltersRequest } from '../types';
import { QueryExecution, ResultMetadata } from '../../types';
import {
  GetRowsRequest,
  GetSummaryRequest,
  GetSummaryResponse,
  UpdateSettingsRequest,
  UpdateSettingsResponse,
} from '../../../../grid/types/common';
import { sanitizeObject } from '../../../../utils/sanitization.utils';
import { getRequestDefaultOptions } from '../../../../utils/request.utils';
import { convertGridFiltersToExtJsFilters } from '../../../../grid/utils/filters';

export class LiveSearchMetadataGridDataProvider extends GridBaseDataProvider<any, any> {
  private pageSize: number = DEFAULT_PAGE_SIZE;
  private response: any;
  private filters: Array<Filter>;

  constructor(public dependencies: any, private queryExecution: QueryExecution | null) {
    super();
  }

  public async getSummary(request: GetSummaryRequest<any>): Promise<GetSummaryResponse> {
    let numItems = 0;

    if (this.queryExecution) {
      this.response = await this.request(request);

      numItems = this.response.total;
    }

    return sanitizeObject({
      summary: this.dependencies.translateFn('{itemsCount} items', { itemsCount: numItems }),
      numItems,
    });
  }

  public async getRows(request: GetRowsRequest<any, any>): Promise<LiveSearchMetadataGridGetRowsResponse> {
    if (!this.queryExecution) {
      return { rawEvents: [] };
    }
    const response = this.response ?? (await this.request(request)),
      data = response.success
        ? response.data.map((result: ResultMetadata): any =>
            Object.assign(
              {
                _id: result._id,
                endpoint: result.endpoint.name,
                endpointId: result.endpoint.id,
                status: result.status,
              },
              result.data
            )
          )
        : [];
    return sanitizeObject({ rawEvents: data });
  }

  public async updateSettings(params: UpdateSettingsRequest<any>): Promise<UpdateSettingsResponse> {
    this.pageSize = params.pageSize ?? DEFAULT_PAGE_SIZE;

    return {};
  }

  async setFilters(request: SetFiltersRequest): Promise<{} | undefined> {
    this.filters = request.filters;
    return;
  }

  private request(request: GetSummaryRequest<any> | GetRowsRequest<any, any>): Promise<any> {
    request.filters = convertGridFiltersToExtJsFilters(this.filters);
    request.pageSize = this.pageSize;
    request.extraParams.queryExecutionId = (this.queryExecution as QueryExecution)._id;

    return this.dependencies.api.clients.LiveSearchResultsMetadata.readRecords(request, getRequestDefaultOptions());
  }
}
